module.exports = __webpack_public_path__ + "static/media/map-second floor.6be38531.png";